import { createEventSender, Environment } from '@spotify-internal/event-sender';
import { createCorrelationIdContext } from '@spotify-internal/event-sender/es5/contexts/correlationId';
import {
  createBaseTransport,
  TransportEvent,
} from '@spotify-internal/transport';
import { createProviders } from '@spotify-internal/transport/es5/providers/spotify_com';
import { requestTransformerCreator } from '@spotify-internal/transport/es5/plugins/request_transformer';
import { Transport } from '@spotify-internal/transport/lib/transport';
import { getCookie } from '../../cookie-utils';

function getTransport(): Promise<Transport> {
  const transport = createBaseTransport({ providers: createProviders() });

  transport.addPlugin(requestTransformerCreator, {
    optionsOverrides: {
      /*
       * This will set 'authorize' to false on all requests.
       * The request token will be automatically added by
       * www-router for spotify.com pages
       */
      authorize: false,
    },
  });

  return new Promise((resolve, reject) => {
    transport.once(TransportEvent.CONNECTED, () => {
      transport.authenticate().then(() => resolve(transport), reject);
    });

    transport.connect();
  });
}

export async function getEventSender() {
  const transport = await getTransport();
  const spT = getCookie('sp_t');
  return createEventSender<Environment.BROWSER | Environment.BROWSER_NON_AUTH>({
    transport,
    context: spT ? [createCorrelationIdContext(spT)] : [],
  });
}
